/**
 * Template for preloader
 */
/** @type {function(): string} */
let preloadTemplate = () => {
    return `
        <div class="add-wrap">
            <div class="add-wrap__title">
                Пожалуйста, подождите. Загружаю данные...
            </div>
            <div class="loader"></div>
        </div>
    `;
};

export default preloadTemplate;
